export default __webpack_public_path__ + "static/media/bobba.84b68a19.webp";